import { render, staticRenderFns } from "./IdentityNumField.vue?vue&type=template&id=6bd47d96&scoped=true"
import script from "./IdentityNumField.vue?vue&type=script&lang=ts"
export * from "./IdentityNumField.vue?vue&type=script&lang=ts"
import style0 from "./IdentityNumField.vue?vue&type=style&index=0&id=6bd47d96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd47d96",
  null
  
)

export default component.exports